import type { Props as ButtonProps } from "@/components/sidebar/Button";
import type { ElementType } from "react";

export function getCollapsedButtonProps(
  isCollapsed?: boolean,
): ButtonProps<ElementType> | undefined {
  if (!isCollapsed) return undefined;
  return {
    className: "min-h-auto",
    wrapperClassName: "p-0.5 grow-0",
    tooltipPlacement: "left",
    tooltipOffset: 8,
  };
}
